import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { URL_API } from '../constante';
import { CategoriaCientifica } from './categoria_cientifica';
import {Utils} from '../shared/utils';

@Injectable()
export class CategoriaCientificaService {

  private documentoUrl = URL_API + '/categoriacientifica';

  get(): Promise<CategoriaCientifica[]> {
    return this.http.get(this.documentoUrl)
                .toPromise()
                .then(response => response.json() as CategoriaCientifica[])
                .catch((error) => this.utils.handleError(error));
  }

  getParents(id: number): Promise<CategoriaCientifica[]> {
    return this.http.get(this.documentoUrl+'/pai/'+id)
                .toPromise()
                .then(response => response.json() as CategoriaCientifica[])
                .catch((error) => this.utils.handleError(error));
  }

  getcategorias(): Promise<CategoriaCientifica[]> {
      return this.http.get(this.documentoUrl)
          .toPromise()
          .then(response => response.json() as CategoriaCientifica[])
          .catch((error) => this.utils.handleError(error));
  }

  constructor(private http: Http, private utils: Utils) {}
}



// WEBPACK FOOTER //
// ./src/app/categoria_cientifica/categoria_cientifica.service.ts